
import React from 'react';

import { Dialog } from '../../../base/dialog';
import { translate } from '../../../base/i18n';

type Props = {

    /**
     * Invoked to obtain translated strings.
     */
    t: Function
};

/**
 * Explains what Focus Mode does. Shown once each time the mode is switched on -
 * to the host who turned it on, and to everyone it applies to - because the
 * change is otherwise hard to read: tiles simply disappear.
 *
 * @param {Props} props - The props of the component.
 * @returns {ReactElement}
 */
function FocusModeInfoDialog({ t }: Props) {
    return (
        <Dialog
            hideCancelButton = { true }
            okKey = 'focusMode.infoAcknowledge'
            titleKey = 'focusMode.infoTitle'
            width = 'small'>
            <div className = 'focus-mode-info-dialog'>
                <p>{ t('focusMode.infoIntro') }</p>
                <ul>
                    <li>{ t('focusMode.infoParticipantView') }</li>
                    <li>{ t('focusMode.infoParticipantShare') }</li>
                    <li>{ t('focusMode.infoHostOversight') }</li>
                </ul>
                <p className = 'focus-mode-info-footnote'>{ t('focusMode.infoFootnote') }</p>
            </div>
        </Dialog>
    );
}

export default translate(FocusModeInfoDialog);
